//lib
import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";

//src
import ContactColumns from "./ContactColumn";
import Table from "../../../components/table/table";
import { ContactTableStyled } from "./ContactTable.styles";
import FilterComponent from "../../../components/filter/filter";
import { useGetContactsFiltersData } from "../../../components/filter/filter.utils";

function ContactTable({ contacts, searchQuery }) {
  const [filterState, setFilterState] = useState([
    {
      key: "contactState",
      value: "Active",
      color: "#E4F9DC",
      titleName: "State",
    },
  ]);
  const { options, isLoading: isFilterLoading } = useGetContactsFiltersData();
  const navigate = useNavigate();

  // Apply filters and search query to contacts
  const filteredContacts = useMemo(() => {
    // Group filters by key
    const groupedFilters = filterState.reduce((acc, { key, value }) => {
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(value);
      return acc;
    }, {});

    // Filter contacts based on the grouped filters
    const filtered = contacts.filter((contact) => {
      return Object.entries(groupedFilters).every(([key, values]) => {
        // If "all" is selected for this key, skip filtering for that key.
        if (values.includes("all")) return true;

        // For the "company" key, check if either companyID or companyName matches one of the selected values.
        if (key === "company") {
          return (
            values.includes(contact.companyID) ||
            values.includes(contact.companyName)
          );
        }

        // For "type" and "contactState" (or any other key), check if the contact's property is in the selected values.
        return values.includes(contact[key]);
      });
    });

    // Apply search query filtering.
    const query = searchQuery?.toLowerCase() || "";
    return filtered.filter((contact) =>
      Object.values(contact).some((value) =>
        value?.toString().toLowerCase().includes(query)
      )
    );
  }, [contacts, filterState, searchQuery]);

  return (
    <ContactTableStyled>
      <div className="contact-table">
        <FilterComponent
          label="Filter Contacts"
          options={options}
          state={filterState}
          setState={setFilterState}
          isLoading={isFilterLoading}
        />
        <div className="table-wrapper">
          <Table
            data={filteredContacts}
            columns={ContactColumns(navigate)}
            // isLoading={isLoading}
            noDataMessage={"No contacts available"}
            sortable
            stickyHeader={true}
          />
        </div>
      </div>
    </ContactTableStyled>
  );
}

export default ContactTable;
